import type { VideoEvidence } from "../ChatEventTypes";
import type { MentionData } from "./Mention";

export function mentionFromVideoEvidence(
	influencer?: VideoEvidence["influencer"] | null,
	socialAccount?: VideoEvidence["social_account"],
): MentionData | null {
	if (influencer?.id) {
		return {
			mention: "influencer",
			mention_type: "influencer",
			id: influencer.id,
			handle: influencer.handle ?? "",
			name: influencer.display_name,
			profile_picture_url: influencer.profile_picture_url ?? undefined,
			follower_count: influencer.follower_count,
			all_follower_counts: influencer.platforms?.map((platform) => ({
				platform: platform.platform,
				follower_count: platform.follower_count ?? 0,
			})),
		};
	}

	if (socialAccount) {
		return {
			mention: "social_account",
			mention_type: "social_account",
			handle: socialAccount.handle,
			platform: socialAccount.platform,
			profile_picture_url: socialAccount.profile_picture_url,
			profile_url: socialAccount.profile_url,
			follower_count: socialAccount.follower_count,
		};
	}

	return null;
}

export function resolveMentionType(
	mention: MentionData,
): MentionData["mention_type"] | undefined {
	return (
		mention.mention_type ??
		(mention.mention as MentionData["mention_type"] | undefined)
	);
}

export function isInfluencerMention(mention: MentionData): boolean {
	return resolveMentionType(mention) === "influencer";
}
